import React, { memo, useMemo } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '../../atoms/icon';

export type DateFilterProps = {
  /**
   *  Select change handler
   */
  onSelect: (x: any) => void;
  /**
   * Selected values.
   */
  values: Date[];
};

const DateFilter: React.FC<DateFilterProps> = ({ onSelect, values = [] }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const onDateChange = (date: Date) => {
    onSelect(date);
    date[1] && setIsOpen(false);
  };

  const Input = React.forwardRef<
    HTMLInputElement,
    React.HTMLProps<HTMLInputElement>
  >(({ value, onClick, onChange }, ref) => (
    <div className="date-picker-container">
      <div className="d-flex align-items-center">
        <Icon className="cal-icon" identifier="calendar-today" />
      </div>
      <input
        placeholder="Reveal Date"
        onClick={onClick}
        className="input bs-input"
        style={{ textIndent: 10 }}
        onFocus={() => setIsOpen(true)}
        onChange={onChange}
        value={value.toString().length > 15 ? value : ''} // Displaying the value only when both start_date and end_date are selected
        ref={ref}
      />
      <div className="d-flex align-items-center">
        <Icon
          className="cal-icon sh-close close-icon"
          identifier="close"
          onClick={() => {
            onSelect([]);
          }}
        />
      </div>
    </div>
  ));

  const startDate = useMemo(() => (values[0] ? values[0] : null), [values]);

  const endDate = useMemo(() => (values[1] ? values[1] : null), [values]);

  return (
    <DatePicker
      onInputClick={() => setIsOpen(true)}
      selected={startDate}
      onChange={onDateChange}
      startDate={startDate}
      endDate={endDate}
      onClickOutside={() => setIsOpen(false)}
      selectsRange
      open={isOpen}
      customInput={<Input />}
      dateFormat="MMM d, yyyy"
    />
  );
};

export default memo(DateFilter);
